// Sidebar / SecondarySidebar
export const SIDEBAR_PANEL_GROUP = "sidebars";
export const PRIMARY_SIDEBAR_PANEL_ID = "primarySidebar";
export const SECONDARY_SIDEBAR_PANEL_ID = "secondarySidebar";
const PRIMARY_SIDEBAR_PANEL_SIZES = { defaultSize: 210, collapsedSize: 48 };
const SECONDARY_SIDEBAR_PANEL_SIZES = { defaultSize: 215, collapsedSize: 48 };

// CoverageTab
export const COVERAGE_TAB_PANEL_GROUP = "coverageTab";
export const COVERAGE_SECTIONS_PANEL_ID = "sections";
export const COVERAGE_TABLE_PANEL_ID = "table";
export const COVERAGE_DOCUMENT_PANEL_ID = "document";
const COVERAGE_SECTIONS_PANEL_SIZES = {
  defaultSize: "300px",
  collapsedSize: "132px",
};
const COVERAGE_DOCUMENT_PANEL_SIZES = {
  defaultSize: "32%",
  collapsedSize: "132px",
};

// TraceDrawer
export const TRACE_DRAWER_PANEL_GROUP = "traceDrawer";
export const TRACE_REQUIREMENTS_PANEL_ID = "requirements";
export const TRACE_DOCUMENT_PANEL_ID = "document";
const TRACE_DOCUMENT_PANEL_SIZES = {
  defaultSize: "66%",
  collapsedSize: "132px",
};

// DocumentEditor
export const DOCUMENT_EDITOR_PANEL_GROUP = "writingEditor";
export const WRITING_EDITOR_PANEL_ID = "editor";
export const VISI_PANEL_ID = "visi";
const VISI_PANEL_SIZES = { defaultSize: "350px" };

// ShreddingReport / TermsInstances
export const SHRED_PANEL_GROUP = "shredding";
export const SHRED_CATEGORY_PANEL_ID = "shredCategoryPanel";
export const SHRED_FILTER_PANEL_ID = "shredFilterPanel";
export const SHRED_DOCUMENT_VIEWER_PANEL_ID = "shredDocumentViewerPanel";
export const SHRED_CATEGORY_PANEL_SIZES = {
  defaultSize: 240,
  collapsedSize: 170,
};
export const SHRED_FILTER_PANEL_SIZES = { defaultSize: 124, collapsedSize: 35 };
export const SHRED_DOCUMENT_VIEWER_PANEL_SIZES = {
  defaultSize: 400,
  collapsedSize: 120,
};

export const PANEL_GROUPS = {
  [SIDEBAR_PANEL_GROUP]: {
    persist: true,
    panels: [
      { panelId: PRIMARY_SIDEBAR_PANEL_ID, ...PRIMARY_SIDEBAR_PANEL_SIZES },
      { panelId: SECONDARY_SIDEBAR_PANEL_ID, ...SECONDARY_SIDEBAR_PANEL_SIZES },
    ],
  },
  [COVERAGE_TAB_PANEL_GROUP]: {
    persist: false,
    panels: [
      { panelId: COVERAGE_SECTIONS_PANEL_ID, ...COVERAGE_SECTIONS_PANEL_SIZES },
      { panelId: COVERAGE_TABLE_PANEL_ID },
      { panelId: COVERAGE_DOCUMENT_PANEL_ID, ...COVERAGE_DOCUMENT_PANEL_SIZES },
    ],
  },
  [TRACE_DRAWER_PANEL_GROUP]: {
    persist: false,
    panels: [
      { panelId: TRACE_REQUIREMENTS_PANEL_ID },
      { panelId: TRACE_DOCUMENT_PANEL_ID, ...TRACE_DOCUMENT_PANEL_SIZES },
    ],
  },
  [DOCUMENT_EDITOR_PANEL_GROUP]: {
    persist: false,
    panels: [
      { panelId: WRITING_EDITOR_PANEL_ID },
      { panelId: VISI_PANEL_ID, ...VISI_PANEL_SIZES },
    ],
  },
  [SHRED_PANEL_GROUP]: {
    persist: false,
    panels: [
      { panelId: SHRED_CATEGORY_PANEL_ID, ...SHRED_CATEGORY_PANEL_SIZES },
      { panelId: SHRED_FILTER_PANEL_ID, ...SHRED_FILTER_PANEL_SIZES },
      {
        panelId: SHRED_DOCUMENT_VIEWER_PANEL_ID,
        ...SHRED_DOCUMENT_VIEWER_PANEL_SIZES,
      },
    ],
  },
};
